//of_note: homeslice and state machine container
//needed: import opcodeMGMT... or make this the opcode & state machine manager
//I LIKE the above idea

import {
    createSlice,
    nanoid,
    createAsyncThunk,
} from '@reduxjs/toolkit';

import { client } from '../../api/client';

//hard coded response of first apps for the auctioneer
//needed for Erik Basics
const test_ops = {
    success: true,
    api_md: {
        e_pnt_prefix: 'https://api.ready.auction',
        media_e_pnt: 'https://api.ready.auction/upload'
    },
    data: [
        {
            lvl_1: 0,
            par_2_0: ['dashboard'],
            api_call_0: 'user_info',//this can be undefined bc if it changes state this is what 
            api_code_0: 'nWH4DSTZ-8LDVVg4pfFkq',
            call_tpe_1: 0,
            params_6: {na_0:'na'},
            state_manip_map_6: {
                lvl_chng_5: false,
                lvl_chng_dir_1: 0,
                dest_par_0: 'self',
            },
            res_map_6: {
                page_views_1: 'this is where and how we do the map',
                new_users_1: 'this is where and how we do the map',
                overall_bids_1: 'this is where and how we do the map',
            },
            result_ops_6: {
                step_a: 'nothing as of now'
            }
        },
        {
            lvl_1: 0,
            par_2_0: ['dashboard'],
            api_call_0: 'get_inventory',//this can be undefined bc if it changes state this is what 
            api_code_0: 'MY6npCSft1BTxZTnGiG1l',
            call_tpe_1: 0,
            params_6: {
                na_0:'na'
            },
            state_manip_6: {
                lvl_chng_5: true,
                lvl_chng_dir_1: -1,
                dest_par_0: 'auction',
            },
            res_map_6: {
                //
                listings_2_6: [
                    {
                        //where do we push the id
                        id_0: 'skKDeCyFd0C1Yt4Zev3FC'
                    }
                ]
            },
            result_ops_6: {
                step_a: 'nothing as of now'
            }
        },
        {
            lvl_1: 1,
            par_: ['auctions'],
            api_call_0: 'create_inventory_item',//this can be undefined bc if it changes state this is what 
            api_code_0: 'e1Vsm1f8ZGg9b7yxO6665',
            call_tpe_1: 1,
            params_6: {
                na_0:'na'
            },
            state_manip_6: {
                lvl_chng_5: true,
                lvl_chng_dir_1: -1,
                dest_par_0: 'auction',
            },
            res_map_6: {
                new_listing_id_0: 'this is where and how we do the map from responses'
            },
            result_ops_6: {
                step_a: 'nothing as of now'
            }
        },
        //come back to the other ops needed for auctions
    ]
};


//of_note: slice inheritence between each other

//configure an init flow after log in and deliver manual opcodes
//changes for each user group type
const initialState = {
    activeCtx: {
        par: 'm',
        child: 'na',
        lvl: 0,
        lvlState: 0,
        causeLvlChng: 1,
        lvlChngDir: -1,
    },
    navClicks: {
        
    },
    core_md: {
        //descript:main state
        loggedIn: false,
        loadedOpcodes: false,
        parent_0: null,
        parent_mode_0: null,
        sub_state_0: null,
        availPars: [//make an api_call
            'm',//dashboard
            'alerts',
            'auctions',
            'auctionFeed',
            'dealGoesOn',
            'docs',
            'event',
            'messaging',
            'moderation',
            'myAuctionSite',
            'myProfile',
            'staff',
            'subscriber',
            'users',
        ],
        //needed:format because it is an entity
        opcode_history: {//of_note:interact with the 'use-history' react-router-dom library
            
        },
        navItems: [
        ],//static elements used for navigation around the spa
        availOpcodes: [
            //requires a call to the api to gather the specific api calls
        ],
        
    },
    app_parents: {
            dashboard: {
                state_0: 'active',
                error: null,
                child_open_0: 'home',//use to nav back
                data_tickers_6: null,//descript:data ticker below tiles
                home: {
                    home_section_6: {//descript:whether or not the child is displayed
                        alerts_5: false,//:*
                        accnt_settings_5: false,//:*
                        subscribers_5: false,//:*
                        schedule_5: false,//:*
                        auctions_5: false,//:*
                        reports_5: false,//:*
                        biz_mgmt_5: false,//:*
                        staff_5: false,//:*
                        docs_5: false,//:*
                        msgs_5: false,//:
                    }
                },
            },
            accnt_settings: {},
            alerts: {
                md_6: {
                    state_0: 'na',
                    mode_0: 'new',
                    modes_2_0: [
                        'new',
                        'read',
                        'details'//of_note:this leads to the 
                    ]
                },
                //needed:object_fmts
                newSection_6: {
                    ids_2_0: [],
                    values_2_6: []
                },
                oldSection_6: {
                    ids_2_0: [],
                    values_2_6: []
                }
            },
            auctions: {
                md_6: {
                    total: 0,
                    liveAuctions: 0,
                    totalItemsSold: 0,
                    categories: null,
                    mode: 'inventory',
                    modes_2_0: [
                        'inventory',
                        'sold',
                        'create',
                        'edit',
                        'schedule',
                        'preview',
                        'staff'
                    ]
                },
                //needed:inventory format
                //needed:listing ctx
                //needed: syntax change remove camel case... i am not a fan
                inventory: {
                    //descript: create and edit are the same views 
                    itemsSection_6: {
                        ids_2_0: [],
                        vals_2_6: [],//of_note:consider loading bids and comments
                    }
                },
                //needed:populate these areas when necessary
                //of_note this is also the editor
                carCreatorData: {
                    sectionsCompleteStatus_6: {
                        total_complete_1: 0,
                        details_status_1: 0,
                        article_status_1: 0,
                        highlights_status_1: 0,
                        media_gallery_status_1: 0,
                    },
                    detailsSection_6: {//storage
                        listing_title_0: '',//state.carCreatorData.detailsSection.listingTitle
                        car_make_0: '',
                        model_0: '',
                        vin_0: '',
                        yr_1: 0,
                        transmission_0: '',
                        engine_0: '',
                        mileage_1: 0,
                        start_price_1: 0,
                        has_reserve_5: false,
                        res_disabled_5: true,
                        reserve_amt_1: '',
                        auction_date_range_2_4: ['', ''],
                        start_time_4: '',
                        //needed: start time is morning
                        end_time_4: '',
                        //needed: start time is morning
                        state_loc_0: '',
                        city_loc_0: '',
                        audience_0: 'Public',
                        exterior_color_0: "purple",
                        interior_color_0: "purple"
                    },
                    articleSection_6: {
                        brief_descript_0: '',
                        brief_descript_gallery_2_3: [],
                        //or depending on the version it should be urls
                        introduction_0: '',
                        introduction_gallery_2_3: [],
                        power_train_0: '',
                        power_train_gallery_2_3: [],
                        exterior_0: '',
                        exterior_gallery_2_3: [],
                        interior_0: '',
                        interior_gallery_2_3: [],
                        chassis_0: '',
                        chassis_gallery_2_3: [],
                        docs_0: '',
                        docs_gallery_2_3: [],
                    },
                    highlightsSection_6: {
                        highlights_2_6: [],
                        ids_2_0: [],
                        values_2_6: []
                    },
                    mediaGallerySection_6: {
                        //needed: create metadata before upoload
                        //needed:links for photos after upload
                        //photos_2_3: [],
                        photos_6: {
                            ids_2_0: [],
                            values_2_6: [],
                            //needed: photo format over in the item formats
                        },
                        photos_2_3: [],
                        videos_2_3: [],
                        embed_videos_2_0: [],
                        docs_2_3: []
                        //needed
                    },
                    //needed: put this on the exterior of the state with the parents
                    refData: {
                        //this will be dynamic and require an 'init' call plus some async thunks
                        //needed:find way to denote that the 
                        car: {
                            make_2_0: [],
                            model_2_0: [],
                            body_styles_2_0: []
                        },
                        location: {//needed:payload flow
                            state_2_0: [],
                            city_2_0: [],
                            zip_2_1: []
                        },
                        color_2_0: []
                        
                    },
                },
                carPreviewItemMap: {
                    val: null,
                },
                carPreviewItemDetsMap: {
                    val: null,
                }
            },
            biz_mgmt: {},
            docs: {},
            msgs: {},
            reports: {},
            schedule: {},
            staff: {},
            subscribers: {},   
    }
};

const homeSlice = createSlice({
    name: 'home',
    initialState,
    reducers: {
        setUserAuthd(state, action){
            console.log(action.payload)
            let status = action.payload;
            state.core_md.loggedIn  = status;
        },
        fieldInfoUpdated(state, action){
            let { par, child, section, item, itemVal } = action.payload;
            state.app_parents[par][child][section][item] = itemVal;
        },
        arrayAddition(state, action) {
            //item should always be an array because this is an array worker
            console.log('array update started');
            //adding depth, and lvl_name
            //highlights_2_6:[{id}].
            const { par, child, itemVal, section, item } = action.payload;
            //item should be split denoted by ':'
            let n_item = null;
            let item_sects = item.split(':');
            let depth_match_props = {
                depth: 0,
                prop: '',
                field_match: '',
                //storage_prop
            };
            //check equal to one, 0, or greater than 0
            if (item_sects.length == 1){
                n_item = item_sects[0];
                //only need this line below to produce original functionality
                state.app_parents[par][child][section][n_item].push(itemVal);
            }else {
                console.log('must finish this logic')
            }
            
            let cnt = -1;
            let loc = 0;
            let found = false;
            
            //need to use a reducer
        },
        //descript:remove item from list
        //reorder after deletion
        arrayRemoval(state, action) {
            //descript:delete specific bullet point
            //value of 'item' in dispatch call
            //`highlights_2_6:${highlight_id}:items_2_6:${n_highlight_list_item['id_0']}`
            
            
            console.log('splicing item from array');
            const { par, child, itemVal, section, item } = action.payload;
            //iterate through the array and delete the correct idx
            state.app_parents[par][child][section][item].push(itemVal)
        },
        //descript:save the new order of the array
        arrayReorder(state, action) {
            console.log('Reordering remainder of the array');
            //make a copy of the array sort by 'curr_idx_1' and change 'idx_1' to the value from 'curr_idx_1'
            const { par, child, itemVal, section, item } = action.payload;
            state.app_parents[par][child][section][item].push(itemVal)
        },
    },
});

export const {
    fieldInfoUpdated,
    arrayAddition,
    setUserAuthd
} = homeSlice.actions;

//descript:components will use the 'component_md' object to map this
//off_note: has the same hierarchy as parents...duh
export const obj_fmts = {
    accnt_settings: {},
    alerts: {
        
    },
    auctions: {
        //adding the other items in carCreatorData
        carCreatorData: {
            highlightsSection_6: {
                highlight_fmt_6: {
                    id_0: null,
                    title_0: null,
                    idx_1: 0,
                    curr_idx_1: 0,
                    items_2_6: []
                },
                highlight_item_fmt_6: {
                    id_0: null,
                    val_0: "value of bullet point item",
                    idx_1: 0,
                    curr_idx_1: 0,
                }
            }
        }
    },
    biz_mgmt: {},
    docs: {},
    msgs: {},
    schedule: {},
    staff: {},
    subscribers: {},
};

//console.log(Object.keys(state))
//needed:expand upon this like grabbing any other field
//export const selectImage = state => state.homeSlice.carCreatorData.articleSection.brief_descript_gallery_2_3;
export const selectImage = state => state.homeSlice.app_parents.auctions.carCreatorData.articleSection_6.brief_descript_gallery_2_3;
export const selectAuth = state => state.homeSlice.core_md.loggedIn;



export const selectSectionData = val => state => {
    const { par, child, section, item } = val;
    //return state.auctionItemMgmt[parSection][section][sectionItem];
    //return state.app_parents[par][child][section][item];
    /*console.log(`${Object.keys(state)}`);
    
    console.log(`${par}\n${child}\n${section}\n${item}`);
    console.log(Object.keys(state['homeSlice'].app_parents['dashboard']));*/
    return state['homeSlice'].app_parents[par][child][section][item];
};

export const fetchTests = createAsyncThunk('homeSlice/todo', async () => {
    console.log('in tests');
    //endpoints are set in the initial call
    //needed:endpoint should be from payload initialization(alright for development)
    //const response = await client.get('http://192.168.1.74:8015/todo')
    const response = await client.get('https://api.ready.auction/todo')

    return response.data
})

export const testPost = createAsyncThunk(
    'homeSlice/testPost',
    async testPayload => {
        console.log('test post')
        const response = await client.post(
            //'http://192.168.1.74:8015/tester',
            'https://api.ready.auction/tester',
            testPayload)
        return response.data
})

export const testLogin = createAsyncThunk(
    'homeSlice/testLogin',
    async testPayload => {
        console.log(`firing away ${Object.values(testPayload)}`)
        const response = await client.postFormData(
            //'http://192.168.1.74:8015/token',
            'https://api.ready.auction/token',
            testPayload)
        console.log(response)
        return response.data
})

export const testLogout = createAsyncThunk(
    'homeSlice/testLogout',
    async testPayload => {
        console.log(`firing away ${Object.values(testPayload)}`)
        const response = await client.postFormData(
            //'http://192.168.1.74:8015/logout',
            'https://api.ready.auction/logout',
            
            testPayload)
        console.log(response)
        return response.data
})

export const testUpload = createAsyncThunk(
    'home/testUpload',
    async testPayload => {
    //async (testPayload, {getState}) => {
    console.log(testPayload)
    const response = await client.post(
        //'http://192.168.1.74:8015/testUpload',
        'https://api.ready.auction/testUpload',
        testPayload
    )

    console.log(response)
    return response.data
})


export default homeSlice.reducer;
